import { Injectable, } from '@angular/core';
import { environment } from 'src/environments/environment'; 

// Drop-in replacement for the @agm/core MapsAPILoader, which is unmaintained and
// incompatible with Ivy-only Angular (v16+). Loads the same Google Maps JS API script.
@Injectable({ providedIn: 'root' })
export class MapsAPILoader {
  private loadPromise: Promise<void> | undefined;

  load(): Promise<void> {

    if (this.loadPromise !== undefined) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + environment.googleMaps.apiKey + '&libraries=places';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load the Google Maps JS API script.'));
        document.body.appendChild(script);
    });
    
    return this.loadPromise;
  }
}
